<template>
        <s-modal 
            :open="open"
            :close="true"
            @close="$emit('close')"
            :title="title"
            >
        <div>
            <div >
                <div style="margin: 10px"  >
                    <div> 
                            <slot></slot>
                    </div>
                    <div style="float:right">
                    <s-button 
                        @onclick=" connectAnonyme()"
                        icon=""
                        :theme="loadingConnect ? 'is-loading is-success' : 'is-success'"
                        label="J'ai compris"
                    />
                    </div>
                </div>
            </div>
        </div>
       
    </s-modal>
  

                   
</template>
<style  scoped>
    .QRcodeClub {
        margin: 10px;
        
    }
    .scanner {
        height: 250px;
        width: 250px;
        margin-left: auto;
        margin-right: auto;
        font-weight: bolder;
    }
    .title {
        font-size: 20px;
        font-weight: bolder;
    }
    .club {
        margin: 10px;
        padding: 10px;
        color: white;
        font-size: 18px;
        border-radius: 20PX;
        background-color: var(--bluebg);
    }
    .club:hover {
        cursor: pointer;
         background-color: #599429;
    }
</style>
<script>
import firebase from "firebase/app"
import classement from '../season/classement.vue';


export default {
  components: { classement },
    props: ["open", "title"],
    data() {
        return {
            loading: false,
            loadingConnect: false,
        }
    },
    mounted() {
      

    },
   
    computed: {
        localhost: {
            get() {
                return window.origin == "http://localhost:8080";
            }
            
        }
    },
    methods: {
       
        verifyCaptcha(fct) {
            
            this.$sendRecaptcha( this.$recaptchaLoaded(), this.$recaptcha('search'), result=>{
                
                if (result.data.data.success) {
                    
                    fct();
                }
            })
        },
        connectAnonyme() {
            this.loadingConnect = true;
            this.verifyCaptcha(()=>{
                 if (this.$store.getters.getUser!=null) {
                    this.$emit("compris");
                 }
                 else {
                 firebase.auth().signInWithEmailAndPassword("anonyme@petanque-app.com","anonyme")
                    .then(() => {
                        var user = firebase.auth().currentUser;
                        if (user.displayName!=this.$ANONYME) {
                            user.updateProfile({
                                displayName: this.$ANONYME
                            })
                        }
                        
                        this.$emit("compris");
                        this.loadingConnect = false;
                        
                    })
                    .catch((error) => {
                        var errorCode = error.code;
                        var errorMessage = error.message;
                        // ...
                    });
                }
            })
           
        }
    }
}
</script>